// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
// eslint-disable-next-line
import Favorite from '@material-ui/icons/Favorite';
// eslint-disable-next-line
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
// eslint-disable-next-line
import UncheckedCircle from '@material-ui/icons/RadioButtonUnchecked';
// eslint-disable-next-line
import CheckedCircle from '@material-ui/icons/CheckCircleOutline';
// eslint-disable-next-line
import Checkbox from '@material-ui/core/Checkbox';
import Slider from "@material-ui/core/Slider"

// FLASH new
import FlashTopBar from "../Flash/FlashTopBar.js"
import FlashHeader from "../Flash/FlashHeader.js"
import FlashSubHeader from "../Flash/FlashSubHeader.js"
import FlashBottomBar from "../Flash/FlashBottomBar.js"
import HelpIcon from "@material-ui/icons/HelpOutline"
import grey from "@material-ui/core/colors/grey"
import Paper from "@material-ui/core/Paper"



// TEST colors
import red from "@material-ui/core/colors/red"
import green from "@material-ui/core/colors/green"


// UTILS
import * as _ from "lodash"

// FLASH
// eslint-disable-next-line
import FlashLogo from "../../static/images/lightning-logo-transparent.png"
import FlashMessage from "./../FlashMessage.js"
// LogRocket
// import LogRocket from 'logrocket'


// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<Ratings>")
//LogRocket.init('sbqpcc/flashdev')



const styles = theme => ({

    //
    // GLOBAL STYLES START
    //

    //
    // APPBAR
    //
    appbarRoot: {
        ...theme.css.appbarRoot,
        // desktop - if more than 600
        [theme.breakpoints.up("md")]: {
            // backgroundColor: theme.palette.primary.dark,
        },
    },

    appbarMessage: {
        ...theme.css.appbarMessage
    },

    //
    // APPHEAD
    //
    appheadRoot: {
        ...theme.css.appheadRoot,
        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            height: theme.css.appheadRoot.mobile.height, // to accomodate for 2 line issues
        },
    },

    appheadMessage: {
        ...theme.css.appheadMessage,
    },
    
    bnavbarRoot: {
        ...theme.css.bnavbarRoot,
    },
    
    contentDiv: {
        ...theme.css.contentDiv,
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: theme.css.contentDiv.desktop.marginTop,
            maxWidth: theme.css.contentDiv.desktop.maxWidth,
        },
    },

    separatorDiv: {
        ...theme.css.separatorDiv,

        margin: 0 ,
        marginBottom: 0,
        borderRadius: 0,

        
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            width: theme.css.separatorDiv.desktop.width,
            height: theme.css.separatorDiv.desktop.height,
            marginTop: theme.css.separatorDiv.desktop.marginTop, // separate sections
            marginLeft: theme.css.separatorDiv.desktop.marginLeft,
//            borderTopLeftRadius: 6,
//            borderTopRightRadius: 6,
        },
        
    },

    checkedCircle: {
        ...theme.css.checkedCircle
    },

    uncheckedCircle: {
        ...theme.css.uncheckedCircle
    },

    //
    // GLOBAL STYLES END
    //
    
    continueButton: {
        margin: 20,
        padding: 8,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },

    disagreeButton_old: {
        margin: 5,
        padding: 8,
        color: theme.palette.primary.contrastText,
        backgroundColor: red[300],
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: red[200],
        },
    },

    flashBolt: {
        flex: 1,
        //        margin: 0,
        margin: "auto", // center the icon
        padding: 0,
        width: 0,
        textAlign: "center",
        cursor: "pointer",
        //        color: theme.palette.primary.contrastText,
        //        backgroundColor: red[400],
        '&:hover': {
            //            backgroundColor: red[300],
        },
        //        borderRadius: 5,
        userSelect: "none",
    },

    flashBoltImg: {
        width: 40,
        marginLeft: 0
    },


    scaleDisabled: {
        color: grey[500]
    },


    scaleEnabledDisagree: {
        color: red[500]
    },


    scaleEnabledAgree: {
        color: green[500]
    },

    
    //
    // scale images
    //
    scaleImg1: {
        margin: "auto",
        width: 30,
        height: 30,
        //        marginLeft: 0
        //        backgroundColor: grey[200],
    },

    scaleImg2: {
        margin: "auto",
        width: 35,
        height: 35,
    },


    scaleImg3: {
        margin: "auto",
        width: 40,
        height: 40,
    },


    scaleImg4: {
        margin: "auto",
        width: 55,
        height: 55,
    },

    scaleImg5: {
        margin: "auto",
        width: 60,
        height: 60,
    },


    disagreeButton: {
        flex: 1,
        margin: 5,
        padding: 8,
        textAlign: "center",
        cursor: "pointer",

        //        color: "#FFFFFF",
        color: grey[700],
        
        backgroundColor: red[100],
        
        border: "3px solid",
        borderColor: red[100],
        borderRadius: 5,
        '&:hover': {
            color: "#FFFFFF",
            backgroundColor: red[700],
            borderColor: red[700],
        },
        userSelect: "none"
    },


    disagreeButtonSelected: {
        flex: 1,
        margin: 5,
        padding: 8,
        textAlign: "center",
        cursor: "pointer",
        
        color: grey[100],

        border: "3px solid",
        borderColor: red[800],
        borderRadius: 5,
        
        backgroundColor: red[800],
        '&:hover': {
            backgroundColor: red[800],
            borderColor: red[800],
        },
        userSelect: "none"
    },

    
    notsureButton: {
        flex: 1,
        margin: 5,
        padding: 8,
        textAlign: "center",
        cursor: "pointer",
        
        //        color: "#FFFFFF",
        color: grey[700],
        backgroundColor: grey[300],

        border: "3px solid",
        borderColor: grey[300],
        borderRadius: 5,
        
        '&:hover': {
            color: "#FFFFFF",
            backgroundColor: grey[700],
            borderColor: grey[700],
        },
        
        userSelect: "none"
        
    },

    notsureButtonSelected: {
        flex: 1,
        margin: 5,
        padding: 8,
        textAlign: "center",
        cursor: "pointer",

        color: grey[100],
        
        border: "3px solid",
        borderColor: grey[800],
        borderRadius: 5,
        
        backgroundColor: grey[800],
        '&:hover': {
            backgroundColor: grey[900],
            borderColor: grey[900],
        },
        userSelect: "none"
    },


    agreeButton: {
        flex: 1,
        margin: 5,
        padding: 8,
        textAlign: "center",
        cursor: "pointer",

        //        color: "#FFFFFF",
        color: grey[800],
        backgroundColor: green[100],
        
        border: "3px solid",
        borderColor: green[100],
        borderRadius: 5,
        
        '&:hover': {
            color: "#FFFFFF",
            backgroundColor: green[700],
            borderColor: green[700],
        },
        userSelect: "none"
    },


    agreeButtonSelected: {
        flex: 1,
        margin: 5,
        padding: 8,
        textAlign: "center",
        cursor: "pointer",
        
        color: grey[100],

        border: "3px solid",
        borderColor: green[700],
        borderRadius: 5,
        
        backgroundColor: green[700],
        '&:hover': {
            backgroundColor: green[800],
            borderColor: green[800],
        },
        userSelect: "none"
    },
    

    backButton: {
        margin: 20,
        padding: 4,
        height: 30,
        fontSize: 11,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
        },
    },

    contactList: {
        margin: 0,
        marginTop: 0,
        // tab from the left
        padding: "0px",
        // inside the container
        width: "100%",
    },

    contactItem: {
        // gap between cards (individual items)
        margin: 0,
        // cursor: "pointer",
        borderRadius: 0, // default 4
    },


    sliderRoot: {
        marginTop: 20,
        marginBottom: 20,
        marginLeft: 50,

        //
        // mobile
        //
        //        [theme.breakpoints.down("md")]: {
        //            marginLeft: "auto",
        //            marginRight: "auto",
        //        },

        

        
        //        backgroundColor: grey[300],
        width: 200,
        zIndex: 0,
        //        height: 48,
        //        display: "flex",
        //        alignItems: "center",
        //        justifyContent: "flex-end",
    },

    sliderContainer: {
        //        width: 200,
        //        padding: 0,
        zIndex: 0,
    },

    // makes the thumb fatter on mobile
    thumbWrapper: {
        //        paddingTop: 24,
        //        height: 48,
        zIndex: 0,
    },

    choiceRoot: {
        display: "flex",
        justifyContent: "space-evenly",
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 10,
        marginRight: 10,
        zIndex: 0,
        //        backgroundColor: grey[400],
    },

    currentTotalPoints: {
        margin: 0,
        marginLeft: 0,
        marginTop: 10,
        textAlign: "center",
        fontSize: 20,
        fontWeight: "bold",
        color: "#FFFFFF",

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            // marginTop: -10,
        },
    },


    issueText: {
        display: "flex",
        marginTop: 256,
        minHeight: 64,
        justifyContent: "center", // horizontal
        alignItems: "center", // vertical
        //backgroundColor: grey[200],


        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: 268,
        },
    },

    //
    // new stuff
    //
    mainDiv: {
        // mobile
        marginTop: 0,
        marginBottom: 120,
        marginLeft: "auto",
        marginRight: "auto",
        padding: 0,
        paddingTop: 90,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            paddingTop: 100,
	    maxWidth: 600,
//            marginBottom: 120,
        },

        color: theme.palette.test.mainFG,
        background: theme.palette.test.mainBG,
    },

    paperRoot: {
        // mobile
        margin: 0,
        maxWidth: "100%",
        padding: 10,
        paddingTop: 10,
        paddingBottom: 10,
//        maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: 15,
            borderRadius: 6,
        },
        
    },

    

})

class Ratings extends Component {

    state = {
        redirectBack: false,
        redirectContinue: false,
        isHelpVisible: false,
    }

    handleContinueClick = () => {
        log.debug("handleContinueClick()")
        // get all the checked contacts
        let checkedItems = _.filter(this.state.gl.statements, ["isChecked", true])
        log.debug("handleContinueClick(): checkedItems = ", checkedItems)

        let rateSum = 0
        for (let len = checkedItems.length, i=0; i<len; ++i) {
            rateSum += checkedItems[i].rate
        }
        log.debug("handleContinueClick(): rateSum = ", rateSum)

        let isNextHelp = rateSum > 0  ? false : true
        log.debug("handleContinueClick(): isNextHelp = ", isNextHelp)
        if(isNextHelp) {
            this.setState({ isHelpVisible: isNextHelp })
            return
        }

        

        let localGL = this.state.gl
        localStorage.setItem("gl", JSON.stringify(localGL))
        log.debug("handleContinueClick(): saved localGL")

        this.setState({redirectContinue: true})
    }


    handleNext = (onError) => {
        let checkedItems = _.filter(this.state.gl.statements, ["isChecked", true])
        log.debug("handleNext(): checkedItems = ", checkedItems)
        log.debug("handleNext(): onError() = ", onError)

        let isNextHelp
        let helpText
        
        if(!checkedItems) {
            isNextHelp = true
            helpText = "Please select a reason"
        } else if (checkedItems.length === 0) {
            isNextHelp = true
            if(this.state.yourReason.isChecked) {
                helpText = "Please select additional reason"
            } else {
                helpText = "Please select a reason"
            }
        }

        if(isNextHelp) {
            onError(helpText)
            return false
        }

        // no help needed, continue to save


        /*
        if(this.state.yourReason.isChecked) {
            let yourReasonStatement = {
                uuid: "yourReason",
                txt: this.state.yourReason.txt,
                issue: this.state.gl.currentIssue,
                isChecked: true,
                rate: 0,
            }

            log.debug(" handleNext(): yourReasonStatement = ", yourReasonStatement)
            // NEXT: start pushing here
            this.state.gl.statements.push(yourReasonStatement)

            let newCheckedItems = _.filter(this.state.gl.statements, ["isChecked", true])
            log.debug(" handleNext(): newCheckedItems after push = ", newCheckedItems)
            
        }
*/

        let localGL = this.state.gl
        localStorage.setItem("gl", JSON.stringify(localGL))
        log.debug("handleNext(): saved localGL")

        return true
        
    }
    

    handleHelpDone = () => {
        this.setState({isHelpVisible: false})
    }

    handleBackClick = () => {
        log.debug("handleBackClick()")
        this.setState({redirectBack: true})
    }

    handleCheckboxChange = uuid => event => {
        log.debug(` handleCheckboxChange(): uuid = ${uuid}, event = ${event}`)
        let item = (_.filter(this.state.gl.statements, ["uuid", uuid]))[0]
        log.debug("handleCheckboxChange(): statement found = ", item)
        if(!item.isChecked) {
            item.isChecked = true
        } else if(item.isChecked === true) {
            item.isChecked = false
        } else if(item.isChecked === false) {
            item.isChecked = false
        }

        log.debug("handleCheckboxChange(): item.isChecked = ", item.isChecked)

        this.setState({gl: this.state.gl})
    }

    handleSliderChange_addupto100 = (statementUUID, event, value) => {
        event.stopPropagation()
        //        log.debug("handleSliderChange(): statementUUID = ", statementUUID)
        //        log.debug("handleSliderChange(): value = ", value)
        let statements = this.state.gl.statements
        let currentIssue = this.state.gl.currentIssue
        statements = _.filter(statements, ["issue.uuid", currentIssue.uuid])
        statements = _.filter(statements, ["isChecked", true])
        // those are filtered to the one's that will be rated
        //        log.debug(" render(): statements = ", statements)

        // let ratedStatements = statements
        let workStatements = statements

        // this statement
        let statement = _.filter(statements, ["uuid", statementUUID])[0]
        //        log.debug(" render(): this statement = ", statement)


        // calculate
        let rate = value

        if(statement.rate - rate > 1) rate = statement.rate - 1
        else if(statement.rate - rate < 1) rate = statement.rate + 1


        let debugIterations = 0
        while(true) {
            debugIterations += 1

            if(debugIterations > 100) break
            
            let rateSum = 0
            let ratedIndexes = []
            for (let len = workStatements.length, i=0; i<len; ++i) {
                if(workStatements[i].uuid !== statement.uuid) {
                    rateSum += workStatements[i].rate
                    if(workStatements[i].rate !== 0)
                        ratedIndexes.push(i)
                }
            }
            //        log.debug(`<FlashStatementsList>: rateSliderStatement(): rateSum = ${rateSum}`)
            
            if((rateSum + rate) <= 100) {
                //            log.debug(`<FlashStatementsList>: rateSliderStatement(): within max, assign new rate`)
	        let newRateStatement = _.find(workStatements, {uuid: statement.uuid})
                newRateStatement.rate = rate
                // ratedStatements = workStatements
            } else {
                //            log.debug("<FlashStatementsList>: rateSliderStatement(): ratedIndexes = ", ratedIndexes)
                // get random number from the lenght and pick the index
                let max = ratedIndexes.length - 1
                let min = 0
                let pickIndex = Math.floor(Math.random() * (max - min + 1)) + min
                //            log.debug("<FlashStatementsList>: rateSliderStatement(): pickIndex = ", pickIndex)
                let i = ratedIndexes[pickIndex]
                //            log.debug("<FlashStatementsList>: rateSliderStatement(): i = ", i)
                workStatements[i].rate -= 1
                // ratedStatements = workStatements
            }
        }

        //        log.debug(" handleSliderChange(): ratedStatements = ", ratedStatements)

        this.setState({
            gl: this.state.gl
        })
        
    }


    handleSliderChange = (statementUUID, event, value) => {
        event.stopPropagation()
        //        log.debug("handleSliderChange(): statementUUID = ", statementUUID)
        //        log.debug("handleSliderChange(): value = ", value)
        let statements = this.state.gl.statements
        let currentIssue = this.state.gl.currentIssue
        statements = _.filter(statements, ["issue.uuid", currentIssue.uuid])
        statements = _.filter(statements, ["isChecked", true])
        // those are filtered to the one's that will be rated
        //        log.debug(" render(): statements = ", statements)

        // this statement
        let statement = _.filter(statements, ["uuid", statementUUID])[0]

        statement.rate = value

        this.setState({
            gl: this.state.gl
        })
        
    }

    handleSliderChange_template = (statementUUID, event, value) => {
        event.stopPropagation()
        //        log.debug("handleSliderChange(): statementUUID = ", statementUUID)
        //        log.debug("handleSliderChange(): value = ", value)
        let statements = this.state.gl.statements
        let currentIssue = this.state.gl.currentIssue
        statements = _.filter(statements, ["issue.uuid", currentIssue.uuid])
        statements = _.filter(statements, ["isChecked", true])
        // those are filtered to the one's that will be rated
        //        log.debug(" render(): statements = ", statements)

        // let ratedStatements = statements
        let workStatements = statements

        // this statement
        let statement = _.filter(statements, ["uuid", statementUUID])[0]
        //        log.debug(" render(): this statement = ", statement)


        // calculate
        let rate = value

        if(statement.rate - rate > 1) rate = statement.rate - 1
        else if(statement.rate - rate < 1) rate = statement.rate + 1


        let debugIterations = 0
        while(true) {
            debugIterations += 1

            if(debugIterations > 100) break
            
            let rateSum = 0
            let ratedIndexes = []
            for (let len = workStatements.length, i=0; i<len; ++i) {
                if(workStatements[i].uuid !== statement.uuid) {
                    rateSum += workStatements[i].rate
                    if(workStatements[i].rate !== 0)
                        ratedIndexes.push(i)
                }
            }
            //        log.debug(`<FlashStatementsList>: rateSliderStatement(): rateSum = ${rateSum}`)
            
            if((rateSum + rate) <= 100) {
                //            log.debug(`<FlashStatementsList>: rateSliderStatement(): within max, assign new rate`)
	        let newRateStatement = _.find(workStatements, {uuid: statement.uuid})
                newRateStatement.rate = rate
                // ratedStatements = workStatements
            } else {
                //            log.debug("<FlashStatementsList>: rateSliderStatement(): ratedIndexes = ", ratedIndexes)
                // get random number from the lenght and pick the index
                let max = ratedIndexes.length - 1
                let min = 0
                let pickIndex = Math.floor(Math.random() * (max - min + 1)) + min
                //            log.debug("<FlashStatementsList>: rateSliderStatement(): pickIndex = ", pickIndex)
                let i = ratedIndexes[pickIndex]
                //            log.debug("<FlashStatementsList>: rateSliderStatement(): i = ", i)
                workStatements[i].rate -= 1
                // ratedStatements = workStatements
            }
        }

        //        log.debug(" handleSliderChange(): ratedStatements = ", ratedStatements)

        this.setState({
            gl: this.state.gl
        })
        
    }

    

    handleDisagreeClick = () => {
        let count = this.state.testBoltCount
        log.debug("handleDisagreeClick(): initial count = ", count)
        if(count >= 0 || count === - 5)
            count = -1
        else
            count -= 1
        log.debug("handleDisagreeClick(): count = ", count)

        this.setState({
            testBoltCount: count,
            testBoltFresh: false,
        })
    }


    handleDisagreeClick2 = () => {
        let count = this.state.testBoltCount2
        log.debug("handleDisagreeClick2(): initial count = ", count)
        if(count >= 0 || count === - 5)
            count = -1
        else
            count -= 1
        log.debug("handleDisagreeClick2(): count = ", count)

        this.setState({
            testBoltCount2: count,
            testBoltFresh2: false,
        })
    }
    

    handleAgreeClick = () => {
        let count = this.state.testBoltCount
        log.debug("handleAgreeClick(): initial count = ", count)
        if(count <= 0 || count === 5)
            count = 1
        else
            count += 1
        log.debug("handleAgreeClick(): count = ", count)

        this.setState({
            testBoltCount: count,
            testBoltFresh: false,
        })
    }


    handleAgreeClick2 = () => {
        let count = this.state.testBoltCount2
        log.debug("handleAgreeClick2(): initial count = ", count)
        if(count <= 0 || count === 5)
            count = 1
        else
            count += 1
        log.debug("handleAgreeClick(): count = ", count)

        this.setState({
            testBoltCount2: count,
            testBoltFresh2: false,
        })
    }
    
    

    handleNotsureClick = () => {
        let count = this.state.testBoltCount
        log.debug("handleNotsureClick(): initial count = ", count)
        count = 0
        log.debug("handleNotsureClick(): count = ", count)

        this.setState({
            testBoltCount: count,
            testBoltFresh: false,
        })
    }


    handleNotsureClick2 = () => {
        let count = this.state.testBoltCount2
        log.debug("handleNotsureClick2(): initial count = ", count)
        count = 0
        log.debug("handleNotsureClick2(): count = ", count)

        this.setState({
            testBoltCount2: count,
            testBoltFresh2: false,
        })
    }

    
    UNSAFE_componentWillMount = () => {
        log.debug("componentWillMount()")
        let localGL = JSON.parse(localStorage.getItem("gl"))
        log.debug("componentWillMount(): localGL = ", localGL)
        this.setState({
            gl: localGL,
            testBoltCount: 0,
            testBoltFresh: true,
            testBoltCount2: 0,
            testBoltFresh2: true,
            variation: {
                  current: "A",
                  A: "/ratings/a",
                  B: "/ratings/b",
              }
        })
    }

    render() {
        const { classes } = this.props

        // redirects first
        if (this.state.redirectBack) {
            return <Redirect push to="/statements"/>
        } else if(this.state.redirectContinue) {
            return <Redirect push to="/summary"/>
        } else if(!this.state.gl.currentIssue) {
            return <Redirect push to="/contacts"/>
        }

        // let items = this.state.gl.contacts
        let items = this.state.gl.statements
        let currentIssue = this.state.gl.currentIssue
        //        log.debug(" render(): items = ", items)
        //        log.debug(" render(): currentIssue = ", currentIssue)
        
        //        let allItems = _.filter(items, ["uuid", "bullettrain-statement-02"])
        //        let statementsItems = _.filter(items, ["issue.uuid", "bullettrain-issue-1"])
        let statementsItems = _.filter(items, ["issue.uuid", currentIssue.uuid])
        // select them twice and ongly get the one's that are checked
        statementsItems = _.filter(statementsItems, ["isChecked", true])
        //        log.debug(" render(): statementsItems = ", statementsItems)

        let nums = []
        for (let i = 1; i <= 100; i++) {
            nums.push(i)
        }
        
        /*
         // NOTES: will possibly use this later
            let rateSum = 0
            for (let len = statementsItems.length, i=0; i<len; ++i) {
                rateSum += statementsItems[i].rate
            }
        */

	return(
            <React.Fragment>
	      <CssBaseline/>

              <FlashMessage isVisible={this.state.isHelpVisible} variant="norates" onDone={this.handleHelpDone}/>

              <FlashTopBar text="Issue Importance" variation={this.state.variation}/>


              <div className={classes.mainDiv}>
                <FlashSubHeader text1={
                    <div style={{
//                        backgroundColor: grey[300],
                        display: "flex",
                        alignItems: "center",
                        width: 350,
                    }}>
                      <div>
                        <HelpIcon style={{fontSize: 30, color: grey[500], paddingTop: 0, marginRight: 5,}}/>
                      </div>
                      <div style={{marginBottom: 5}}>
                        <Typography className={classes.subheaderText} variant="h6">
                          Show how important this is
                        </Typography>
                      </div>
                    </div>
                }>
                  <Typography className={classes.subheaderText}
                              variant="subtitle2"
                              style={{
                                  fontSize: 18,
                                  marginLeft: 10
                              }}>
                    <div style={{display: "inline", fontWeight: 400}}>User the sliders to rate each reason. Assign 1 to 100 points.</div>
                  </Typography>
                </FlashSubHeader>
                
                <FlashHeader text={this.state.gl.currentIssue.txt}/>

                <div className={classes.separatorDiv}>
                  <Typography variant="subtitle1" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    Reasons
                  </Typography>
                </div>
                
                  <ul className={classes.contactList}>
                    {statementsItems.map((value, index) => (
                        <Paper className={classes.paperRoot} key = {index}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                            <div style={{marginTop: 15}}>
                              <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 18, fontWeight: 400 }}>
                                {value.txt}
                              </Typography>
                              <div className={classes.sliderRoot}>
                                <div style={{display: "inline"}}>
                                  <Slider
                                    classes={{
                                        container: classes.sliderContainer,
                                        thumbWrapper: classes.thumbWrapper,
                                    }}
                                    value={value.rate}
                                    onChange={(event, eventValue) => this.handleSliderChange(value.uuid, event, eventValue)}
                                    min={1}
                                    max={100}
                                    step={1}
                                  />
                                </div>
                              </div>
                            </div>
                            <div style={{marginRight: 20}}>
                              <Typography variant="h6" style={{fontSize: 18}}>
                                {value.rate}
                              </Typography>
                            </div>
                          </div>
                        </Paper>
                    ))}
                  </ul>
              </div>

              <FlashBottomBar
                backButton={{
                    text: "BACK",
                    link: "/statements",
                    //                    onClick: this.handleBack
                }}
                nextButton={{
                    text: "NEXT",
                    link: "/preview",
                    onClick: this.handleNext,
                    onError: this.handleError,
                }}/>
              
            </React.Fragment>
	)
    }
}

Ratings.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {name: "Ratings"})(Ratings)

